import React from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface AutomationsPromptBlockFieldContainerProps {
  children: React.ReactNode;
  label?: string;
}

export const AutomationsPromptBlockFieldContainer = ({
  children,
  label,
}: AutomationsPromptBlockFieldContainerProps): JSX.Element => {
  return (
    <Box px={4} pb={2} pt={4} className="PromptBlock__FieldContainer">
      {label && <Text mb={2}>{label}</Text>}
      <Box className="Automations__FieldContainer">{children}</Box>
    </Box>
  );
};
